"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapMember = exports.mapGroupMember = void 0;
const types_1 = require("@wix/ambassador-social-groups-v2-group-member-with-profile/types");
const types_2 = require("@wix/ambassador-members-v1-member/types");
function mapGroupMember({ member, badges, connections = {}, }) {
    const memberId = member.memberId;
    const isPrivate = member.profile?.privacyStatus === types_1.PrivacyStatus.PRIVATE;
    return {
        memberId,
        isPrivate,
        connections,
        siteMemberId: memberId,
        badges: badges?.[memberId] || [],
        name: member.profile?.nickname,
        imageUrl: member.profile?.imageUrl,
        role: member.role?.value || types_1.Role.UNKNOWN_ROLE,
        answersCount: member.membershipQuestionAnswersCount,
        contactId: member.profile?.contactId,
    };
}
exports.mapGroupMember = mapGroupMember;
function mapMember(member, badges) {
    const memberId = member.id;
    const isPrivate = member.privacyStatus === types_2.PrivacyStatusStatus.PRIVATE;
    return {
        memberId,
        isPrivate,
        siteMemberId: memberId,
        slug: member.profile?.slug,
        badges: badges?.[memberId] || [],
        name: member.profile?.nickname,
        imageUrl: member.profile?.photo?.url,
        contactId: member.contactId,
    };
}
exports.mapMember = mapMember;
//# sourceMappingURL=selectors.js.map